/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const publicChallengeTranslationDataSchema = z.object({
  lang: z.string(),
  title: z.string().nullable(),
  definition: z.string(),
  usageNotes: z.string().nullable(),
  examples: z.string().nullable(),
});

export const getPublicChallengeTranslationResponseSchema = createApiResponseSchema(
  publicChallengeTranslationDataSchema,
) as import('zod').ZodSchema<IAPI<IPublicChallengeTranslation>>;

export type IPublicChallengeTranslation = z.infer<typeof publicChallengeTranslationDataSchema>;
export type IGetPublicChallengeTranslationResponse = IAPI<IPublicChallengeTranslation>;
